/**
 * @generated SignedSource<<e66bcf79f4a01759df64c76f179ef587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MultichainWalletSelectorFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EthereumAddWalletFragment" | "GnosisSafeAddWalletFragment" | "TezosAddWalletFragment">;
  readonly " $fragmentType": "MultichainWalletSelectorFragment";
};
export type MultichainWalletSelectorFragment$key = {
  readonly " $data"?: MultichainWalletSelectorFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultichainWalletSelectorFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultichainWalletSelectorFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EthereumAddWalletFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GnosisSafeAddWalletFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TezosAddWalletFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b9dd63d9ee65a50d29ebe4731cd63221";

export default node;
